import { render, staticRenderFns } from "./BlockForms.vue?vue&type=template&id=23528ec8&scoped=true&"
import script from "./BlockForms.vue?vue&type=script&lang=ts&"
export * from "./BlockForms.vue?vue&type=script&lang=ts&"
import style0 from "./BlockForms.vue?vue&type=style&index=0&id=23528ec8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23528ec8",
  null
  
)

export default component.exports